export interface ILanguage {
  languageId: number;
  languageName: string;
  languageCountry: string;
  languageISO: string;
  countryCode: string;
  currencySymbol: string;
  currencyFormat: string;
  currencySymbolFloat: string;
  currencyName: string;
  formatDate: string;
  formatTime: string;
  decimalSeparator: string;
  decimalNumbers: number;
  decimalNumbersMoney: number;
  thousandSeparator: string;
  textFloat: string;
  dir?: string;
  rtl?: boolean;
  authorLanguage?: string;
  dayNames: string;
  monthNames: string;
  isSelected: boolean;
  momentConfig: IMommentConfig;
  secondsCode: string; // 1 sec
  minutesCode: string; // 1 min
  hoursCode: string; // 1 hr
  shortDayMonths: string;
  shortDayNames: string;
  shortDayNames2: string;
  firstWeekDay: number;
}

export interface IMommentConfig {
  months: string[]; // ['January', 'February', 'March', 'April', 'May', 'June', etc]
  monthsShort: string[]; // ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', etc]
  weekdays: string[]; // ['Sunday', 'Monday', 'Tuesday', 'Wednesday', etc]
  weekdaysShort: string[]; // ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
  weekdaysMin: string[]; // ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa']
}
